
// MSAL imports
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

let credentialsAcquired = false;

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {

    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account)

        credentialsAcquired = true;
    }

    if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.payload.accessToken) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);

        credentialsAcquired = true;
    }
});

export const getAccessToken = async () => {   
    const account = msalInstance.getActiveAccount();
    return await msalInstance.acquireTokenSilent(loginRequest);
}